import {DropdownModel} from '../component/dropdown.model';

export class Enums {

  public static BooleanTypes = {
    'true': 'true',
    'false': 'false',
    list: function() {
      return [this.true, this.false];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone);

    }
  };

  static OperationTypes = {
    addition: '+',
    subtraction: '-',
    multiplication: '*',
    division: '-',
    list: function() {
      return [this.addition,
        this.subtraction,
        this.multiplication,
        this.division];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static QuestionSubjects = {
    math: 'math',
    list: function() {
      return [
        this.math
      ];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static QuestionTopics = {
    algebra: 'algebra',
    arithmetic: 'arithmetic',
    finance: 'finance',
    geometry: 'geometry',
    measurements: 'measurements',
    patterns: 'patterns',
    statistics: 'statistics',
    list: function() {
      return [
        this.algebra,
        this.arithmetic,
        this.geometry,
        this.measurements,
        this.patterns,
        this.statistics
      ];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone);

    }
  };

  static QuestionCategories = {
    count: 'count',
    addition: 'addition',
    subtraction: 'subtraction',
    multiplication: 'multiplication',
    sizeComparison: 'sizeComparison',
    numberPatterns: 'numberPatterns',
    imagePatterns: 'imagePatterns',
    placeValue: 'placeValue',
    shapes: 'shapes',
    division: 'division',
    transformations: 'transformations',
    fractions: 'fractions',
    negativeNumbers: 'negativeNumbers',
    orderingNumbers: 'orderingNumbers',
    perimeter: 'perimeter',
    area: 'area',
    rounding: 'rounding',
    dataRepresentation: 'dataRepresentation',
    lengthAndDistance: 'lengthAndDistance',
    list: function() {
      return [
        this.addition,
        this.area,
        this.count,
        this.dataRepresentation,
        this.division,
        this.fractions,
        this.imagePatterns,
        this.lengthAndDistance,
        this.multiplication,
        this.numberPatterns,
        this.perimeter,
        this.placeValue,
        this.rounding,
        this.shapes,
        this.sizeComparison,
        this.subtraction,
        this.transformations
      ];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone, 'categories.');

    }
  };

  static QuestionSubcategories = {
    areaFromShape: 'areaFromShape',
    barChart: 'barChart',
    cornerNameFromImage: 'cornerNameFromImage',
    countDiscrimination: 'countDiscrimination',
    countNumbers: 'countNumbers',
    countMultipleNumbers: 'countMultipleNumbers',
    countPairs: 'countPairs',
    countShapes: 'countShapes',
    doubleAddition: 'doubleAddition',
    doubleAdditionNeededAmount: 'doubleAdditionNeededAmount',
    doubleSubtraction: 'doubleSubtraction',
    fractionSetupFromImage: 'fractionSetupFromImage',
    imagePatternSingleFill: 'imagePatternSingleFill',
    measurementComparison: 'measurementComparison',
    measurementInput: 'measurementInput',
    numberPatternSingleFill: 'numberPatternSingleFill',
    perimeterFromShape: 'perimeterFromShape',
    proportionSetupFromImage: 'proportionSetupFromImage',
    repeatedAddition: 'repeatedAddition',
    roundingWholeNumber: 'roundingWholeNumber',
    shapeNameFromImage: 'shapeNameFromImage',
    shapeSingleDiscriminationCount: 'shapeSingleDiscriminationCount',
    singleAddition: 'singleAddition',
    singleAdditionNeededAmount: 'singleAdditionNeededAmount',
    singleDivision: 'singleDivision',
    singleMultiplication: 'singleMultiplication',
    singleSubtraction: 'singleSubtraction',
    singleSubtractionNeededAmount: 'singleSubtractionNeededAmount',
    sizeComparisonNumbers: 'sizeComparisonNumbers',
    sizeComparisonSymbols: 'sizeComparisonSymbols',
    sizeComparisonWords: 'sizeComparisonWords',
    translation2D: 'translation2D',
    unitHouse: 'unitHouse',
    list: function() {
      return [
        this.areaFromShape,
        this.barChart,
        this.cornerNameFromImage,
        this.countDiscrimination,
        this.countMultipleNumbers,
        this.countNumbers,
        this.countPairs,
        this.countShapes,
        this.doubleAddition,
        this.doubleAdditionNeededAmount,
        this.doubleSubtraction,
        this.fractionSetupFromImage,
        this.imagePatternSingleFill,
        this.measurementComparison,
        this.measurementInput,
        this.numberPatternSingleFill,
        this.perimeterFromShape,
        this.proportionSetupFromImage,
        this.repeatedAddition,
        this.roundingWholeNumber,
        this.shapeNameFromImage,
        this.shapeSingleDiscriminationCount,
        this.singleAddition,
        this.singleAdditionNeededAmount,
        this.singleDivision,
        this.singleMultiplication,
        this.singleSubtraction,
        this.singleSubtractionNeededAmount,
        this.sizeComparisonNumbers,
        this.sizeComparisonSymbols,
        this.sizeComparisonWords,
        this.unitHouse
      ];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone);

    }
  };

  static QuestionRepresentations = {
    equation: 'equation',
    images: 'images',
    equationAndImages: 'equationAndImages',
    grid: 'grid',
    barChart: 'barChart',
    numberLine: 'numberLine',
    list: function() {
      return [
        this.equation,
        this.images,
        this.equationAndImages,
        this.grid,
        this.barChart,
        this.numberLine
      ];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone);

    }
  };

  static AnswerTypes = {
    multipleChoice: 'multipleChoice',
    input: 'input',
    interaction: 'interaction',
    list: function() {
      return [
        this.multipleChoice,
        this.input,
        this.interaction
      ];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list(), includeNone, 'answerTypes.');

    }
  };

  static QuestionImages = {
    Apple: 'Apple',
    'Apple Yellow': 'Apple Yellow',
    Aubergine: 'Aubergine',
    'Band Aid 20 Pack': 'Band Aid 20 Pack',
    'Band Aid Big': 'Band Aid Big',
    'Band Aid Small': 'Band Aid Small',
    Bolt: 'Bolt',
    Bone: 'Bone',
    'Bone Green': 'Bone Green',
    Branch: 'Branch',
    'Branch Green': 'Branch Green',
    Brick: 'Brick',
    'Butternut Squash': 'Butternut Squash',
    Cantalope: 'Cantalope',
    'Donut Toy': 'Donut Toy',
    'Donut Toy Blue': 'Donut Toy Blue',
    'Double Wood': 'Double Wood',
    'Electroshock Cream': 'Electroshock Cream',
    'Fat Fish': 'Fat Fish',
    'Frostbite Cream': 'Frostbite Cream',
    Gauze: 'Gauze',
    Hammer: 'Hammer',
    'Health Pack Big': 'Health Pack Big',
    'Health Pack Small': 'Health Pack Small',
    'Herb Bowl': 'Herb Bowl',
    'Honey Pot': 'Honey Pot',
    'Light Blue Crystal': 'Light Blue Crystal',
    'Lizard Toy': 'Lizard Toy',
    'Lizard Toy Green': 'Lizard Toy Green',
    Mango: 'Mango',
    'Mango Green': 'Mango Green',
    Meat: 'Meat',
    'Mouse Toy': 'Mouse Toy',
    'Nail Box': 'Nail Box',
    Nail: 'Nail',
    Onions: 'Onions',
    Papaya: 'Papaya',
    Pepper: 'Pepper',
    Pineapple: 'Pineapple',
    'Pineapple Green': 'Pineapple Green',
    'Poison Rash Cream': 'Poison Rash Cream',
    Potato: 'Potato',
    'Potion Blue': 'Potion Blue',
    'Potion Green': 'Potion Green',
    'Potion Red': 'Potion Red',
    'Purple Crystal': 'Purple Crystal',
    Screw: 'Screw',
    'Small Blueberry Branch': 'Small Blueberry Branch',
    Spade: 'Spade',
    Spinach: 'Spinach',
    Strawberry: 'Strawberry',
    'Sunburn Cream': 'Sunburn Cream',
    Teddy: 'Teddy',
    'Tennis Ball': 'Tennis Ball',
    'Tennis Ball Green': 'Tennis Ball Green',
    Watercress: 'Watercress',
    Watermelon: 'Watermelon',
    Wood: 'Wood',
    'Yarn Ball': 'Yarn Ball',
    'Yarn Ball Green': 'Yarn Ball Green',
    list: function(): string[] {
      return [this.Apple,
        this['Apple Yellow'],
        this.Aubergine,
        this['Band Aid 20 Pack'],
        this['Band Aid Small'],
        this['Band Aid Big'],
        this.Bolt,
        this.Bone,
        this['Bone Green'],
        this.Branch,
        this['Branch Green'],
        this.Brick,
        this['Butternut Squash'],
        this.Cantalope,
        this['Donut Toy'],
        this['Donut Toy Blue'],
        this['Double Wood'],
        this['Electroshock Cream'],
        this['Fat Fish'],
        this['Fat Fish'],
        this['Frostbite Cream'],
        this.Gauze,
        this.Hammer,
        this['Health Pack Big'],
        this['Health Pack Small'],
        this['Herb Bowl'],
        this['Honey Pot'],
        this['Light Blue Crystal'],
        this['Lizard Toy'],
        this['Lizard Toy Green'],
        this.Mango,
        this['Mango Green'],
        this.Meat,
        this['Mouse Toy'],
        this['Nail Box'],
        this.Nail,
        this.Onions,
        this.Papaya,
        this.Pineapple,
        this['Pineapple Green'],
        this['Poison Rash Cream'],
        this.Potato,
        this['Potion Blue'],
        this['Potion Green'],
        this['Potion Red'],
        this['Purple Crystal'],
        this.Screw,
        this['Small Blueberry Branch'],
        this.Spade,
        this.Spinach,
        this.Strawberry,
        this['Sunburn Cream'],
        this.Teddy,
        this['Tennis Ball'],
        this['Tennis Ball Green'],
        this.Watercress,
        this.Watermelon,
        this.Wood,
        this['Yarn Ball'],
        this['Yarn Ball Green']
      ];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static SizeComparisonTypes = {
    equal: 'equal',
    greater: 'greater',
    less: 'less',
    list: function() {
      return [this.equal, this.greater, this.less];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static PerimeterShapes = {
    Arrow1: 'Arrow1',
    Diamond1: 'Diamond1',
    Pentagon1: 'Pentagon1',
    Pentagon2: 'Pentagon2',
    OddShape1: 'OddShape1',
    OddShapeSquare1: 'OddShapeSquare1',
    Rectangle1x2: 'Rectangle1x2',
    Rectangle2x3: 'Rectangle2x3',
    Square1x1: 'Square1x1',
    Triangle1: 'Triangle1',
    list: function() {

      return [
        this.Arrow1,
        this.Diamond1,
        this.Pentagon1,
        this.Pentagon2,
        this.OddShape1,
        this.OddShapeSquare1,
        this.Rectangle1x2,
        this.Rectangle2x3,
        this.Square1x1,
        this.Triangle1
      ];

    },
    dropdownModel: function(): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static Roundings = {
    '10': 10,
    '100': 100,
    '1000': 1000,
    list: function() {
      return [
        this['10'],
        this['100'],
        this['1000']];
    },
    dropdownList: function(): DropdownModel[] {

      const list = [];
      for (const key of this.list()) {
        list.push(
          new DropdownModel(key.toString(), key.toString(), null)
        );
      }

      return list;

    }
  };

  static AreaShapes = {
    OddRectangle1_4x5: 'OddRectangle1_4x5',
    OddShape1_3x4: 'OddShape1_3x4',
    OddShape1_3x5: 'OddShape1_3x5',
    OddShape1_4x4: 'OddShape1_4x4',
    OddShape1_4x5: 'OddShape1_4x5',
    OddShape2_3x4: 'OddShape2_3x4',
    OddShape2_3x5: 'OddShape2_3x5',
    OddShape2_4x4: 'OddShape2_4x4',
    OddShape2_4x5: 'OddShape2_4x5',
    OddShape3_3x4: 'OddShape3_3x4',
    OddShape3_3x5: 'OddShape3_3x5',
    OddShape3_4x4: 'OddShape3_4x4',
    OddShape3_4x5: 'OddShape3_4x5',
    OddShape4_3x5: 'OddShape4_3x5',
    OddShape4_4x4: 'OddShape4_4x4',
    OddShape4_4x5: 'OddShape4_4x5',
    OddShape5_3x4: 'OddShape5_3x4',
    OddShape5_3x5: 'OddShape5_3x5',
    OddShape5_4x4: 'OddShape5_4x4',
    OddShape5_4x5: 'OddShape5_4x5',
    Rectangle1_3x4: 'Rectangle1_3x4',
    Rectangle1_3x5: 'Rectangle1_3x5',
    Rectangle1_4x5: 'Rectangle1_4x5',
    Square1_4x4: 'Square1_4x4',
    list: function() {

      return [
        this.OddRectangle1_4x5,
        this.OddShape1_3x4,
        this.OddShape1_3x5,
        this.OddShape1_4x4,
        this.OddShape1_4x5,
        this.OddShape2_3x4,
        this.OddShape2_3x5,
        this.OddShape2_4x4,
        this.OddShape2_4x5,
        this.OddShape3_3x4,
        this.OddShape3_3x5,
        this.OddShape3_4x4,
        this.OddShape3_4x5,
        this.OddShape4_3x5,
        this.OddShape4_4x4,
        this.OddShape4_4x5,
        this.OddShape5_3x4,
        this.OddShape5_3x5,
        this.OddShape5_4x4,
        this.OddShape5_4x5,
        this.Rectangle1_3x4,
        this.Rectangle1_3x5,
        this.Rectangle1_4x5,
        this.Square1_4x4
      ];

    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static Shapes = {
    circle: 'circle',
    square: 'square',
    rectangle: 'rectangle',
    parallelogram: 'parallelogram',
    trapezium: 'trapezium',
    triangle: 'triangle',
    pentagon: 'pentagon',
    hexagon: 'hexagon',
    octagon: 'octagon',
    list: function(): string[] {
      return [this.circle,
        this.square,
        this.rectangle,
        this.parallelogram,
        this.trapezium,
        this.triangle,
        this.pentagon,
        this.hexagon,
        this.octagon];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static ShapeImages = {
    circle: {
      yellow: 'CircleYellow',
      red: 'CircleRed',
      green: 'CircleGreen',
      blue: 'CircleBlue',
      purple: 'CirclePurple',
      orange: 'CircleOrange'
    },
    square: {
      yellow: 'SquareYellow',
      red: 'SquareRed',
      green: 'SquareGreen',
      blue: 'SquareBlue',
      purple: 'SquarePurple',
      orange: 'SquareOrange'
    },
    rectangle: {
      yellow: 'RectangleYellow',
      red: 'RectangleRed',
      green: 'RectangleGreen',
      blue: 'RectangleBlue',
      purple: 'RectanglePurple',
      orange: 'RectangleOrange'
    },
    parallelogram: {
      yellow: 'ParallelogramYellow',
      red: 'ParallelogramRed',
      green: 'ParallelogramGreen',
      blue: 'ParallelogramBlue',
      purple: 'ParallelogramPurple',
      orange: 'ParallelogramOrange'
    },
    trapezium: {
      yellow: 'TrapeziumYellow',
      red: 'TrapeziumRed',
      green: 'TrapeziumGreen',
      blue: 'TrapeziumBlue',
      purple: 'TrapeziumPurple',
      orange: 'TrapeziumOrange'
    },
    triangle: {
      yellow: 'TriangleYellow',
      red: 'TriangleRed',
      green: 'TriangleGreen',
      blue: 'TriangleBlue',
      purple: 'TrianglePurple',
      orange: 'TriangleOrange'
    },
    pentagon: {
      yellow: 'PentagonYellow',
      red: 'PentagonRed',
      green: 'PentagonGreen',
      blue: 'PentagonBlue',
      purple: 'PentagonPurple',
      orange: 'PentagonOrange'
    },
    hexagon: {
      yellow: 'HexagonYellow',
      red: 'HexagonRed',
      green: 'HexagonGreen',
      blue: 'HexagonBlue',
      purple: 'HexagonPurple',
      orange: 'HexagonOrange'
    },
    octagon: {
      yellow: 'OctagonYellow',
      red: 'OctagonRed',
      green: 'OctagonGreen',
      blue: 'OctagonBlue',
      purple: 'OctagonPurple',
      orange: 'OctagonOrange'
    },
    list: function(): string[] {
      const array = [];
      for (const key of Object.keys(this)) {
        if (key !== 'list' && key !== 'dropdownList') {
          const value = this[key];
          for (const subKey of Object.keys(value)) {
            array.push(value[subKey]);
          }
        }
      }

      return array;
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static Corners = {
    right: 'right',
    acute: 'acute',
    obtuse: 'obtuse',
    list: function(): string[] {
      return [
        this.right,
        this.acute,
        this.obtuse
      ];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static Metrics = {
    length: 'length',
    weight: 'weight',
    list: function() {
      return [
        this.length,
        this.weight
      ];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());

    }
  };

  static Comparisons = {
    min: 'min',
    max: 'max',
    list: function() {
      return [
        this.min,
        this.max
      ];
    },
    dropdownList: function(): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static MetricLengths = {
    mm: 'mm',
    cm: 'cm',
    dm: 'dm',
    m: 'm',
    km: 'km',
    list: function() {
      return [
        this.mm,
        this.cm,
        this.dm,
        this.m,
        this.km
      ];
    },
    dropdownList: function(): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static MetricWeights = {
    mg: 'mg',
    gr: 'gr',
    kg: 'kg',
    list: function() {
      return [
        this.mg,
        this.gr,
        this.kg
      ];
    },
    dropdownList: function (): DropdownModel[] {

      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static USCustomaryLengths = {
    in: 'in',
    ft: 'ft',
    ac: 'ac',
    list: function() {
      return [
        this.in,
        this.ft,
        this.ac
      ];
    },
    dropdownList: function(): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static USCustomaryWeights = {
    oz: 'oz',
    lb: 'lb',
    list: function() {
      return [
        this.oz,
        this.lb
      ];
    },
    dropdownList: function(): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static ParameterNames = {
    firstParam: 'firstParam',
    secondParam: 'secondParam',
    thirdParam: 'thirdParam',
    fourthParam: 'fourthParam',
    fifthParam: 'fifthParam',
    sixthParam: 'sixthParam',
    seventhParam: 'seventhParam',
    eighthParam: 'eighthParam',
    ninthParam: 'ninthParam',
    paramNameByIndex: function(index) {

      if (index === 0) {

        return this.firstParam;

      } else if (index === 1) {

        return this.secondParam;

      } else if (index === 2) {

        return this.thirdParam;

      } else if (index === 3) {

        return this.fourthParam;

      } else if (index === 4) {

        return this.fifthParam;

      } else if (index === 5) {

        return this.sixthParam;

      } else if (index === 6) {

        return this.seventhParam;

      } else if (index === 7) {

        return this.eighthParam;

      } else if (index === 8) {

        return this.ninthParam;

      }

    }
  };

  static CompetitionTypes = {
    school: 'school',
    consumer: 'consumer',
    multiSchool: 'multiSchool',
    list: function() {
      return [this.school, this.consumer, this.multiSchool];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list(), includeNone, 'competitionTypes.');
    }
  };

  static CompetitionGoalTypes = {
    answers: 'answers',
    time: 'time',
    list: function() {
      return [this.answers];
    },
    dropdownList: function(includeNone = false): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list(), includeNone, 'competitionGoalTypes.');
    }
  };


}
